module.exports = __webpack_public_path__ + "img/alex_competencies_grey.220fcd9e.svg";